import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginService } from '../services/login/login.service';
import { useAuth } from '../contexts/AuthProvider';

const useLogin = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (username: string, password: string) => {
        setIsLoading(true);
        setError(null);
        try {
            const authPayload = await loginService.login(username, password);
            await login(authPayload);
            navigate('/');
        } catch (err: any) {
            console.error(`Login failed: ${err.message}`);
            setError(err.message || 'Login failed. Please check your credentials.');
        } finally {
            setIsLoading(false);
        }
    };

    return { handleLogin, isLoading, error };
};

export default useLogin;

